<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" 
                                :placeholder="['Start Time', 'End Time']" style="width:100%"
                                 @ok="handleOk"
                                @change="handleDateChange"
                                />
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Sites">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'" @change="onChangeSites">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Terminal">
                                <a-select v-model="inputTerminal" showSearch placeholder="All Terminals" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
 
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                // inputDate: [],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                // inputTerminal: [],
                inputPromo: 0,
                onUsReport: [],
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                inputTerminal: 0,
                JsonData: [],
            }
        },
        watch: {
            inputSite(newSiteIds) {
              this.updateTerminaOptions(newSiteIds)
            },
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            component_x.sort(component_x.terminalOptions);

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            handleDateChange(dates) {
                this.inputDate = dates;
            },

            async updateTerminaOptions(siteId){
                let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
                this.terminalOptions = terminals;
                this.terminalOptions.push({id: 0, name: ' All Terminals'})
                this.terminalOptions = this.terminalOptions.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },

            validateDateRange(dates) {
                if (!dates || dates.length !== 2) return;

                const [start, end] = dates;
                if (!start || !end) return;

                const isAllSites = !this.inputSite || this.inputSite.length === 0;
                const maxMonths = isAllSites ? 1 : 6;

                const diffInMonths = moment(end).diff(moment(start), 'months', true);
                if (diffInMonths > maxMonths) {
                    if (this.$message && this.$message.error) {
                        if (maxMonths > 1) {    
                            this.$message.error(`You can only select up to ${maxMonths} month${maxMonths > 1 ? 's' : ''} range for selected sites.`);
                        } else {
                            this.$message.error(`You can only select up to ${maxMonths} month${maxMonths > 1 ? 's' : ''} range for All Sites.`);
                        }
                    }
                    this.inputDate = null;
                }
            },

            handleOk(dates) {
               this.validateDateRange(dates);
            },
            generateReport: async function () {
                if (!this.inputDate || this.inputDate.length !== 2 || !this.inputDate[0] || !this.inputDate[1]) {
                    if (this.$message && this.$message.error) {
                        this.$message.error("Please select a valid date range before generating the report.");
                        return;
                    }
                }

                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'on_us_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date +  '&terminal_id=' + this.inputTerminal, null, "BXI-File");

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    // doc.addImage(reportLogo, "PNG", 10, 5, 15, 15);
                    let headers = [
                        {content: 'Date', styles: {halign: 'center'}},
                        {content: 'Store Code', styles: {halign: 'center'}},
                        {content: 'Store', styles: {halign: 'center'}},
                        {content: 'Terminal', styles: {halign: 'center'}},
                        {content: 'Trans ID', styles: {halign: 'center'}},
                        {content: 'SDS No', styles: {halign: 'center'}},
                        {content: 'Status', styles: {halign: 'center'}},
                        {content: 'Delivery Status', styles: {halign: 'center'}},
                        {content: 'OnUsChargeTo', styles: {halign: 'center'}},
                        {content: 'Delivery Reason', styles: {halign: 'center'}},
                        {content: 'Cashier', styles: {halign: 'center'}},
                        {content: 'Rider', styles: {halign: 'center'}},
                        {content: 'Authorized ID', styles: {halign: 'center'}},
                        {content: 'Authorized Name', styles: {halign: 'center'}},
                        {content: 'Amount', styles: {halign: 'center'}},
                    ]
                    let detailColStyles = {
                        0: {cellWidth: 20},
                        1: {cellWidth: 15},
                        2: {cellWidth: 30}, 
                        3: {cellWidth: 30}, 
                        4: {cellWidth: 15},
                        5: {cellWidth: 20}, 
                        6: {cellWidth: 15},
                        7: {cellWidth: 15}, 
                        8: {cellWidth: 20}, 
                        9: {cellWidth: 25}, 
                        10: {cellWidth: 25}, 
                        11: {cellWidth: 25}, 
                        12: {cellWidth: 15}, 
                        13: {cellWidth: 25},
                        14: {cellWidth: 25},  // 320  
                    }

                    for(var x=0; x < siteSpecific.length; x++){
                        let grand_total = 0
                        let grand_net = 0
                        let trans_count = 0
                        this.onUsReport = siteSpecific[x].report_details

                        if(x > 0 && this.onUsReport.length > 0){
                            doc.addPage();
                        }

                        let terminal = ''
                        if (this.inputTerminal > 0){
                            terminal = siteSpecific[x].report_details[0].TERMINAL
                        } else {
                            terminal = 'All Terminals'
                        }

                        let reportData = [];
                        doc.addImage(reportLogo, "PNG", 10, 5, 15, 15);
                        // report headers
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        let design_y = 20
                        design_y = design_y + 5;
                        doc.text(15,design_y,`On Us Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Site: " + siteSpecific[x].report_details[0].SITE)
                        doc.text(15,design_y + 5,"Terminal: " + terminal)


                        this.onUsReport = siteSpecific[x].report_details
                        // report data
                        if(this.onUsReport.length > 0){
                            for(let i=0; i < this.onUsReport.length; i++){
                                let reportLine = this.onUsReport[i]
                                let detail = [
                                    {content: moment(reportLine.DATE).format('MM-DD-YYYY'), styles: {halign: 'center'}},
                                    {content: reportLine.STORE_CODE, styles: {halign: 'center'}},
                                    {content: reportLine.SITE, styles: {halign: 'center'}},
                                    {content: reportLine.TERMINAL, styles: {halign: 'center'}},
                                    {content: reportLine.TRANS_ID, styles: {halign: 'center'}},
                                    {content: reportLine.SDS_NO, styles: {halign: 'center'}},
                                    {content: reportLine.STATUS, styles: {halign: 'center'}},
                                    {content: reportLine.DEL_STATUS, styles: {halign: 'center'}},
                                    {content: reportLine.REASON_TYPE, styles: {halign: 'center'}},
                                    {content: reportLine.DEL_REASON, styles: {halign: 'center'}},
                                    {content: reportLine.CASHIER, styles: {halign: 'center'}},
                                    {content: reportLine.RIDER, styles: {halign: 'center'}},
                                    {content: reportLine.AUTHORIZED_ID, styles: {halign: 'center'}},
                                    {content: reportLine.AUTHORIZED_NAME, styles: {halign: 'center'}},
                                    {content: reportLine.AMOUNT, styles: {halign: 'right'}},
                                ]
                
                                // grand_gross += Number(reportLine.gross_amount)
                                grand_net += Number(reportLine.AMOUNT)
                                trans_count++;
                                reportData.push(detail)
                                
                                // let subtotal_detail = []
                                let grand_total_detail = []
                                let total_count = []
                                if(i == this.onUsReport.length-1){
                                    grand_total_detail = [
                                        '', '', '', '', '', '', '', '', '', '', '', '', '',
                                        {content: 'Total Amount: ', styles: {fontStyle: 'bold', halign: 'left'}},
                                        {content: this.convertToCurrency(grand_net), styles: {fontStyle: 'bold'}}
                                    ]
                                    total_count = [
                                        '', '', '', '', '', '', '', '', '', '', '', '', '',
                                        {content: 'Total Count: ', styles: {fontStyle: 'bold', halign: 'left'}},
                                        {content: this.convertToCurrency(trans_count), styles: {fontStyle: 'bold'}}
                                    ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(grand_total_detail)
                                    reportData.push(total_count)

                                    //create table
                                    design_y = design_y + 10
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [headers],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 8,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    // subtotal = 0
                                    // grand_total = 0
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    let pageCount = doc.internal.getNumberOfPages();
                    let footer_x = 340
                    let footer_y = 205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "On Us Report", footer_x, footer_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                if (!this.inputDate || this.inputDate.length !== 2 || !this.inputDate[0] || !this.inputDate[1]) {
                    if (this.$message && this.$message.error) {
                        this.$message.error("Please select a valid date range before generating the report.");
                        return;
                    }
                }

                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('YYYY-MM-DD');
                let to_header= this.inputDate[1].format('YYYY-MM-DD');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'on_us_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date +  '&terminal_id=' + this.inputTerminal, null, "BXI-File");

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let site_specific = [];
                    for(var x=0; x < siteSpecific.length; x++){
                        this.onUsReport = siteSpecific[x].report_details

                        let headers = ['Date', 'Store Code', 'Store', 'Terminal', 'Trans ID', 'SDS No', 'Status',
                                     'Delivery Status', 'OnUsChargeTo', 'Delivery Reason', 'Cashier', 'Rider',
                                     'Authorized ID', 'Authorized Name', 'Amount']
                        let reportData = []
                        if(this.onUsReport.length > 0){
                            // let grand_gross = 0
                            let grand_net = 0
                            let trans_count = 0
                            for(let i=0; i < this.onUsReport.length; i++){
                                let reportLine = this.onUsReport[i]
                                let detail = [
                                    moment(reportLine.DATE).format('MM-DD-YYYY'),
                                    reportLine.STORE_CODE,
                                    reportLine.SITE,
                                    reportLine.TERMINAL,
                                    reportLine.TRANS_ID,
                                    reportLine.SDS_NO,
                                    reportLine.STATUS,
                                    reportLine.DEL_STATUS,
                                    reportLine.REASON_TYPE,
                                    reportLine.DEL_REASON,
                                    reportLine.CASHIER,
                                    reportLine.RIDER,
                                    reportLine.AUTHORIZED_ID,
                                    reportLine.AUTHORIZED_NAME,
                                    reportLine.AMOUNT
                                ]

                                // grand_gross += Number(reportLine.gross_amount)
                                grand_net += Number(reportLine.AMOUNT)
                                trans_count++;
                                reportData.push(detail)
                                
                                let grand_total_detail = []
                                let total_count = []
                                if(i == this.onUsReport.length-1){
                                    grand_total_detail = [
                                                         '', '', '', '', '', '', '', '', '', '', '', '', '',
                                                         'Total Amount',
                                                         this.convertToCurrency(grand_net)]
                                    total_count = [
                                                         '', '', '', '', '', '', '', '', '', '', '', '', '',
                                                         'Total Count',
                                                         this.convertToCurrency(trans_count)]
                                    reportData.push(grand_total_detail)
                                    reportData.push(total_count)
                                } else {
                                    //     sub_qty = 0
                                    //     sub_gross = 0
                                    //     sub_net = 0
                                    // }   
                                }
                            }
                        }

                        let terminal = ''
                        if (this.inputTerminal > 0){
                            terminal = siteSpecific[x].report_details[0].TERMINAL
                        } else {
                            terminal = 'All Terminals'
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push(["Site: " + siteSpecific[x].report_details[0].SITE])
                        reportData.push(["Terminal: " + terminal])
                        reportData.push(["On Us Report", "", "", "Generated By: " + printed_by])
                        reportData.push(["For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            })));
                            newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                    obj[i] = '';
                                }
                            }
                        });
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data');
                }
                this.spinning= false;
            },
            clearJsonData(){
                this.JsonData = [];
            },
            async onChangeSites(value){
                let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + value, null);
                this.terminalOptions = terminals;
                this.sort(this.terminalOptions);

                // validate date after changing sites
                this.validateDateRange(this.inputDate);
            } //end of onChangeSites
        }
    };
</script>

<style></style>